module.exports = __webpack_public_path__ + "static/media/iv_retirement.a7034ce4.svg";